
//公共库
import { Message, MessageBox } from "element-ui";
import { Component, Vue } from "vue-property-decorator";

//本地引入
import GFunc from "@/utils/gFunc";
import Pagination from "@/comp/Pagination/index.vue";
import { getAppBaseApi, getHeaders } from "@/api/request";
import { getUnionList, setUnion, unionList, bloggerGuildSet, unionPwdReset } from "@/api/request/player";

//组件
@Component({
  name: "UnionList",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private avatarList: string[] = [];
  private listLoading: boolean = true;

  //定义变量
  private listQuery: any = {
    //页码数据
    row: 20,
    page: 1,

    //上传数据
    name: "",
  };

  //创建
  created() {
    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const { data } = await unionList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //处理创建
  private handleCreate(): void {
    //数据赋值
    this.addForm = {
      //临时数据
      leader_id_str: "", //负责人ID

      //基本信息
      name: "", //公会名称
      phone: "", //手机号
      email: "", //邮箱地址
      leader_id: 0, //负责人ID
      company_ssm: "", //公司ssm
      leader_name: "", //负责人昵称
      company_addr: "", //公司地址
      leader_credential: "", //负责人证件
      user_name: "", // 管理员账号
      password: "", // 管理员密码
    };
    this.ssmFileList = [];
    this.creFileList = [];

    //显示对话框
    this.dialogVisible = true;
  }

  //充值密码
  private handleResetPassword(row: any): void {
    //显示提示
    MessageBox.confirm("确认重置该工会管理员密码？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //获取数据
        const data: any = await unionPwdReset({ id: row.id });

        //修改成功
        if (data.status == 0) {
          MessageBox.confirm("重置密码：" + data.data.password, "重置成功", {
            confirmButtonText: "确定",
            type: "info",
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //头像预览
  private openAvatar(src: string): void {
    //数据赋值
    this.avatarList = [];
    this.avatarList.push(src);
  }

  //博主工会设置
  private async handleBloggerGuildSet() {
    //数据赋值
    this.unionList = [];
    this.setForm = {
      //临时数据
      blogger_id_str: "", //博主ID

      //基本信息
      gh_id: 0, //公会ID
      blogger_id: 0, //博主ID
    };

    //显示界面
    this.setDialogVisible = true;

    //获取数据
    this.setDialogLoading = true;

    //获取数据
    const { data } = await getUnionList({});

    //数据赋值
    this.unionList = data.result;
    this.unionList.unshift({ id: 0, name: "请选择工会" });

    //获取数据
    this.setDialogLoading = false;
  }

  //----------------------------------------- 添加/编辑 -----------------------------------------
  //定义变量
  private dialogVisible: boolean = false;
  private dialogLoading: boolean = false;

  //添加表单
  private addForm: any = {
    //临时数据
    leader_id_str: "", //负责人ID

    //基本信息
    name: "", //公会名称
    phone: "", //手机号
    email: "", //邮箱地址
    leader_id: 0, //负责人ID
    company_ssm: "", //公司ssm
    leader_name: "", //负责人昵称
    company_addr: "", //公司地址
    leader_credential: "", //负责人证件
    user_name: "", // 管理员账号
    password: "", // 管理员密码
  };

  //处理关闭
  private handleClose(): void {
    //隐藏界面
    this.dialogVisible = false;
  }

  //处理创建
  private async createData() {
    //判断处理
    if (!this.checkPassword(this.addForm.password)) return Message({ message: "管理员密码必须包含数字、字母、特殊字符其中2中", type: "error", duration: 5 * 1000 });
    if (this.addForm.name == "") return Message({ message: "请输入公会名称！", type: "error", duration: 5 * 1000 });
    if (this.addForm.leader_name == "") return Message({ message: "请输入负责人昵称！", type: "error", duration: 5 * 1000 });
    if (Number(this.addForm.leader_id_str) == 0) return Message({ message: "请输入负责人ID！", type: "error", duration: 5 * 1000 });
    if (this.addForm.leader_credential == "") return Message({ message: "请添加负责人证件", type: "error", duration: 5 * 1000 });
    if (this.addForm.company_ssm == "") return Message({ message: "请添加公司ssm", type: "error", duration: 5 * 1000 });
    if (this.addForm.phone == "") return Message({ message: "请输入手机号", type: "error", duration: 5 * 1000 });
    if (this.addForm.email == "") return Message({ message: "请输入邮箱地址", type: "error", duration: 5 * 1000 });
    if (this.addForm.company_addr == "") return Message({ message: "请输入公司地址", type: "error", duration: 5 * 1000 });
    if (this.addForm.user_name == "") return Message({ message: "请输入管理员账号", type: "error", duration: 5 * 1000 });
    if (this.addForm.password == "") return Message({ message: "请输入管理员密码", type: "error", duration: 5 * 1000 });

    //数据赋值
    this.addForm.leader_id = Number(this.addForm.leader_id_str);

    //显示等待
    this.dialogLoading = true;

    //数据赋值
    await setUnion(this.addForm);

    //隐藏等待
    this.dialogLoading = false;

    //隐藏对话框
    this.dialogVisible = false;

    //获取数据
    this.getList();

    //显示提示
    this.$notify({
      title: "成功",
      message: "创建成功",
      type: "success",
      duration: 2000,
    });
  }

  //检测密码
  private checkPassword(str: string): boolean {
    const reg = /^(?:(?=.*[0-9])(?=.*[a-zA-Z])|(?=.*[0-9])(?=.*[^a-zA-Z0-9])|(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])).+$/;
    return reg.test(str);
  }

  //----------------------------------------- 博主公会设置 -----------------------------------------
  //定义变量
  private unionList: any[] = [];
  private setDialogVisible: boolean = false;
  private setDialogLoading: boolean = false;

  //添加表单
  private setForm: any = {
    //临时数据
    blogger_id_str: "", //负责人ID

    //基本信息
    gh_id: 0, //公会ID
    blogger_id: 0, //博主ID
  };

  //处理关闭
  private handleCloseSet(): void {
    //隐藏界面
    this.setDialogVisible = false;
  }

  //设置工会
  private async setBloggerUnion() {
    //判断处理
    if (this.setForm.gh_id == 0) return Message({ message: "请选择工会！", type: "error", duration: 5 * 1000 });
    if (Number(this.setForm.blogger_id_str) == 0) return Message({ message: "请输入博主ID！", type: "error", duration: 5 * 1000 });

    //数据赋值
    this.setForm.blogger_id = Number(this.setForm.blogger_id_str);

    //显示等待
    this.setDialogLoading = true;

    //数据赋值
    await bloggerGuildSet(this.setForm);

    //隐藏等待
    this.setDialogLoading = false;

    //隐藏对话框
    this.setDialogVisible = false;

    //显示提示
    this.$notify({
      title: "成功",
      message: "设置成功",
      type: "success",
      duration: 2000,
    });
  }

  //----------------------------------------- 图片处理 -----------------------------------------
  //定义变量
  private ssmFileList: any[] = [];
  private creFileList: any[] = [];
  private getHeads = getHeaders();
  private getAction = this.getApi();

  //获取API
  private getApi(): string {
    const reg = /^https?\:\/\//;
    const baseApi = getAppBaseApi();
    const isMatch = reg.test(baseApi);
    const prefix = !isMatch ? window.location.origin : "";
    return `${prefix}${baseApi}/adm/picture/files`;
  }

  //图片上传
  private handlePicBeforeUploadCommon(file: any) {
    //数据赋值
    const index = file.name.lastIndexOf(".");
    const extension = file.name.substr(index + 1);
    const extensionList = ["png", "PNG", "jpg", "JPG", "jpeg", "JPEG", "gif", "svga"];
    const isLt2M = file.size / 1024 / 1024 < 5;

    //判断结果
    if (!isLt2M) {
      this.$notify({
        title: "失败",
        message: "图片或动画资源不可超出5M",
        type: "warning",
        duration: 2000,
      });
      return false;
    } else if (extensionList.indexOf(extension) < 0) {
      this.$notify({
        title: "失败",
        message: "当前文件格式不支持",
        type: "error",
        duration: 2000,
      });
      return false;
    }
  }

  //图片预览
  private handlePicPreviewCommon(file: any): void {
    //数据赋值
    this.dialogImageUrl = file.url;

    //显示界面
    this.dialogImageVisible = true;
  }

  //移除图片
  private handlePicRemove(file: any, fileList: any): void {
    //清空数据
    this.ssmFileList = [];
    this.addForm.company_ssm = "";
  }

  //移除图片
  private handleCreRemove(file: any, fileList: any): void {
    //清空数据
    this.creFileList = [];
    this.addForm.leader_credential = "";
  }

  //图片上传成功
  private handlePicUploadSuccess(response: any, file: any, fileList: any): void {
    //数据赋值
    this.ssmFileList = fileList;
    this.addForm.company_ssm = response.data.images[0];
  }

  //图片上传成功
  private handleCreUploadSuccess(response: any, file: any, fileList: any): void {
    //数据赋值
    this.creFileList = fileList;
    this.addForm.leader_credential = response.data.images[0];
  }

  //----------------------------------------- 图片处理 -----------------------------------------
  //定义变量
  private dialogImageUrl: any = null;
  private dialogImageVisible: boolean = false;
}
